import { create } from 'zustand'

interface AidaFileDropState {
  over: boolean
}

export const useAidaFileDropStore = create<AidaFileDropState>(() => ({
  over: false,
}))
